module.exports = __webpack_public_path__ + "ClientApp/content/petLossGroupHeader.jpg";